import {
  SET_NOTE_ID,
} from '../actions/ui';

export default function ui(state = {
    note_id:false
}, {type, payload}) {
  switch (type) {
      case SET_NOTE_ID:
        return {
          ...state,
          note_id: payload
        }
      default:
          return state;
  }
}